<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <h1 class="text-uppercase text-center mb-3">
        {{ $t('PostProgram.ProgramEndedTitle') }}
      </h1>
      <p> {{ $t('PostProgram.ProgramEndedDesc') }}</p>
      <p class="mt-5"><a href="https://glade.com/en-us" target="_blank" class="btn-link">{{ $t('PostProgram.ShopBtn') }}</a></p>
    </div>
  </main>
</template>
<script>
export default {
  props: {
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
